import { createTolgee, TRANSLATIONS } from '@simsm/ui-i18n';
import type { TolgeeInstance } from '@tolgee/web';
import { bindLanguageSideEffects } from './language-side-effects';

export function createFrontofficeTolgee(): TolgeeInstance {
  // Cloud sync (Tolgee live editor) is opt-in via VITE_TOLGEE_REMOTE=true.
  // Default: staticData-only — local JSON in libs/ui/i18n is the source of
  // truth during design work, so adding keys doesn't require pushing to
  // Tolgee cloud before they render.
  const useRemote = import.meta.env.VITE_TOLGEE_REMOTE === 'true';
  const apiKey = import.meta.env.VITE_TOLGEE_API_KEY;
  const apiUrl = import.meta.env.VITE_TOLGEE_API_URL;
  return createTolgee({
    ...(useRemote && apiKey ? { apiKey } : {}),
    ...(useRemote && apiUrl ? { apiUrl } : {}),
    staticData: TRANSLATIONS,
  });
}

let instance: TolgeeInstance | undefined;

/**
 * One instance per document, created on first use and bound to the document's
 * language declaration there and then — before React renders, so nothing is
 * ever painted under a `lang` that contradicts it. A singleton rather than a
 * `useMemo`: StrictMode invokes the memo factory twice, and a second instance
 * would carry a second subscription writing the same attribute.
 */
export function getFrontofficeTolgee(): TolgeeInstance {
  if (!instance) {
    instance = createFrontofficeTolgee();
    bindLanguageSideEffects(instance);
  }
  return instance;
}
